<template>
  <div :class="$style.article">
    <div :class="$style.content">
      <img :src="`${$cdnLink}/suspend/qingbao/close.png`" alt @click="close" />
      <div :class="$style.articleText" v-if="article_info.type === 2">
        <!-- 菜单配置跳转不为无跳转并且内容展示类型为折叠展示 -->
        <div v-if="active_menu.jump_mode && article_info.show_type === 2" :class="$style.jumpMode" @click="readMore()">
          <!-- jump_mode 2.bt盒子 3.玩心盒子 -->
          <span>打开{{ active_menu.jump_mode == 2 || active_menu.jump_mode == 3 ? '盒子' : '微信公众号' }}，查看更多</span>
          <img :src="`${$cdnLink}/suspend/qingbao/xiangyou.png`" alt="" />
        </div>
        <div v-html="article_info.article" :class="$style.textContent" ref="textArticleEl"></div>
      </div>
      <div :class="$style.articleText" v-if="article_info.type === 1">
        <div v-if="active_menu.jump_mode && article_info.show_type === 2" :class="$style.jumpMode" @click="readMore()">
          <span>打开{{ active_menu.jump_mode == 2 || active_menu.jump_mode == 3? '盒子' : '微信公众号' }}，查看更多</span>
          <img :src="`${$cdnLink}/suspend/qingbao/xiangyou.png`" alt="" />
        </div>
        <iframe :src="article_info.article" :class="$style.linkFrame"></iframe>
      </div>
    </div>
    <Popup v-if="popupVisible" :type="activeMenuType" :account="account_name" :accountId="account_id" text="获取更多攻略资讯" @close="popupVisible = false"></Popup>
    <FullScreenView v-if="fullScreenShow" @close="fullScreenShow=false" :link="fullScreenLink"></FullScreenView>
    <BoxDownLoad v-if="boxDownLoadShow" @close="boxDownLoadShow=false" type="wx"></BoxDownLoad>
  </div>
</template>

<script>
import { articleApi } from '@/api/suspend.js';
import Popup from '../common/Popup.vue';
import { mapState } from 'vuex';
import { notifyRemindReadArticleId, gameOpenDownloads } from '@/bridge/AppJsBridge';
import FullScreenView from '@/components/FullScreenView.vue'
import { handleTextArticle } from '@/libs/business/suspend';
import BoxDownLoad from '../common/boxDownload.vue';
import { generJumpLink } from '@/libs/business/box'

export default {
  name: '',
  data() {
    return {
      active_menu: {},
      article_info: {},
      popupVisible: false,
      fullScreenShow: false,
      fullScreenLink: "",
      boxDownLoadShow: false,
    };
  },
  mounted() {
    this.getArticle();
  },
  computed: {
    ...mapState({
      account_name: (state) => state.suspend.account_name,
      account_id: (state) => state.suspend.account_id,
      raidersList: (state) => state.suspend.raidersList,
      messagesList: (state) => state.suspend.messagesList,
      activeMenuType: (state) => state.suspend.active_menu_type,
    }),
  },
  components: {
    Popup,
    FullScreenView,
    BoxDownLoad
  },
  methods: {
    handleTextLinkClick() {
      const textArticleEl = this.$refs.textArticleEl;
      if (textArticleEl) {
        const aEl = textArticleEl.getElementsByTagName('a');
        for ( let i =0; i < aEl.length; i++ ) {
          aEl[i].addEventListener('click', (e) => {
            this.fullScreenLink = aEl[i].dataset.href;
            this.fullScreenShow = true;
          })
        }
      }
    },
    async getArticle() {
      const { active_article, redirectArticle } = this.$store.state.suspend;
      if (!redirectArticle) {
        // 点击文章的时存储的当前分类
        this.active_menu = this.$store.state.suspend.active_menu;
        this.getArticleText(active_article.article_id);
      } else {
        // 强提醒或首页跳转进来情况
        this.getArticleText(redirectArticle.article_id);
        // 内容类型为消息(3)时，处理红点缓存逻辑
        if (redirectArticle.type === 3) {
          this.$store.commit('suspend/SET_MESSAGES_CACHE', { menu_id: redirectArticle.menu_id, article_id: redirectArticle.article_id });
        }
        // 因为每篇文章是否存在跳转是配置文章所在分类下，这里找到当前文章所在分类，获取到是否跳转(jump_mode)值
        const menuList = redirectArticle.type === 3 ? this.messagesList : this.raidersList;
        this.active_menu = menuList.find(item => item.menu_id === redirectArticle.menu_id) || {};
        this.$store.commit('suspend/CHANGE_STATE', { redirectArticle: null });
      }
    },
    async getArticleText(article_id) {
      const r = await articleApi({ article_id });
      this.article_info = r.content;
      if (this.article_info.type === 2) {
        this.article_info.article = handleTextArticle(this.article_info.article)
      }
      setTimeout(() => {
        this.handleTextLinkClick();
      }, 200);
      notifyRemindReadArticleId(article_id)
    },
    close() {
      this.$emit('showSideWindow');
    },
    async readMore() {
      if (this.active_menu.jump_mode == 3) {
        const gameUrl = await generJumpLink()
        gameOpenDownloads({
          gameUrl: gameUrl.wxBoxForumUrl
        })
        this.boxDownLoadShow = true;
      }
      if (this.active_menu.jump_mode === 1) {
        this.popupVisible = true;
      }
      this.article_info.show_type = 1;
    },
  },
};
</script>

<style lang="scss" module>
.article {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 340px;
    height: 402px;
    background: #ffffff;
    border-radius: 13px;
    font-size: 12px;
    padding: 15px 20px;
    > img {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 12px;
      height: 12px;
      z-index: 10;
    }
    .articleText {
      .jumpMode {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.5) 70%,
          rgba(255, 255, 255, 0.9) 90%,
          rgba(255, 255, 255, 1) 100%
        );
        display: flex;
        justify-content: center;
        align-items: flex-end;
        > span {
          font-size: 10px;
          color: #ff5b58;
          line-height: 30px;
        }
        > img {
          display: inline-block;
          width: 10px;
          height: 10px;
          margin-bottom: 10px;
          margin-left: 3px;
        }
      }
      .linkFrame {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
      }
      .textContent {
        width: 100%;
        height: 100%;
        line-height: 1.2;
        a {
          color: #ff5b58;
        }
        img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
